import { isNumber } from 'lodash';
const MAX_INT = 2147483648; // 2^31
export const convertToDuration = (input) => input.toString();
export const convertToPrice = (input) => {
    if (isNumber(input)) {
        return parseFloat(input.toFixed(2));
    }
    const [base, decimals] = input.split('.');
    const priceDecimals = decimals === null || decimals === void 0 ? void 0 : decimals.slice(0, 2);
    const price = `${base}${priceDecimals ? `.${priceDecimals}` : ''}`;
    return parseFloat(price);
};
export const convertToNumber = ({ input, options = { isFloat: false, isNegative: false }, }) => {
    const floatValue = options.isFloat ? Number.parseFloat(input) : Number.parseInt(input, 10);
    if (!Number.isNaN(floatValue)) {
        if (floatValue > MAX_INT) {
            throw new Error('Exceeded maximum number size');
        }
        return options.isNegative ? floatValue : Math.abs(floatValue);
    }
};
